<template>
  <section class="section pt-0">
    <pilates_member-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import Pilates_memberDatatable from "./pilates_member_datatable/Index.vue";

export default {
  name: "Pilates_memberIndex",
  components: { Pilates_memberDatatable },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {},
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    let v = this;
    v.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
